import React, { Component } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import "../styles/PrintPage.css";
import { formatNumber, urlToImage, calculateTotalsForGender, urlEncoder } from "../lib/utils.js";
import params from "jquery-param";

type Props = {
  selectedTargets: [],
  selectedLocations: [],
  ageRange: any
};

const mapStateToProps = (state, ownProps) => {
  return {
    selectedLocations: state.selectedLocations,
    selectedTargets: state.selectedTargets,
    ageRange: state.ageRange,
    currentView: state.currentView,
    results: state.results
  };
};

class PrintPageContainer extends Component<Props, State> {



  render() {
    let maxValue=1000;
    const byCountry = this.props.results.reduce((accumulator, value) => {
      if (accumulator[value.country]) {
        accumulator[value.country] = _.orderBy(
          [...accumulator[value.country], value],
          "name"
        );
      } else {
        accumulator[value.country] = [value];
      }
      return accumulator;
    }, {});
    const results = Object.keys(byCountry).reduce((array, key) => {
      array[key] = byCountry[key].reduce((accumulator, value) => {
        if (accumulator[value.name]) {
          accumulator[value.name] = {
            ...accumulator[value.name],
            [value.gender]: value.reach,
            country: value.country,
            label: value.name
          };
        } else {
          accumulator[value.name] = {
            [value.gender]: value.reach,
            country: value.country,
            label: value.name
          };
        }
        if(value.reach > maxValue){
          maxValue = value.reach;
        }
        return accumulator;
      }, {});
      return array;
    }, {});
    const graphData = _.map(results,(value => _.map(value, o => o)));

    maxValue*=1.5; 
    
    return (
      <div className="column">
        <button className="navigator__button print-button" onClick={() => window.print()} >Print</button>
        
        <div className="page page__front" >
          <div>Gruvi</div>
          <div>Audience</div>
          <div>Calculator Results</div>
        </div>
        <div className="page page__graphs" >
          <div> Gruvi audience calculator results</div>
          <div className="specs">
            <div>
              Movie Name
            </div>
            <div>
              countrys (Na,Us)
            </div>
          </div>

          <div className="target-options">
            targeting options
          </div>
          <div className="targets">
            {this.props.selectedTargets.map(o => o.map( target =><div>{target.name}</div>))}
          </div>
          <div className="result-charts">
            {/*graphData.map((data,index) =>
              <div className="chart" >
                <div className="country">{data[0].country}</div>
                  <BarChart height={800} width={300}data={data} margin={{top: 5, right: 30, left: 20, bottom: 5}}>
                    <CartesianGrid strokeDasharray="3 3"/>
                    <XAxis dataKey="label"/>
                    <YAxis hide={index !== 0} domain={[0,maxValue]}/>
                    <Tooltip/>
                    <Bar dataKey="male" barSize={15} fill="#8884d8" />
                    <Bar dataKey="female" barSize={15} fill="#82ca9d" />
                  </BarChart>
              </div>
            )*/}
          </div>
          <div className="print-footer">
            <div className="print-footer__female">
              <div className="print-footer__female-color"/>
              Female
            </div>
            <div className="print-footer__male">
              <div className="print-footer__male-color"/>
              Male
            </div>
            <img className="print-footer__logo" src="https://s3-eu-west-1.amazonaws.com/reach-calculator-v2/img/logo.jpg" />
          </div>
        </div>
        <div className="page page__tables" >
          <div> Gruvi audience calculator results</div>
          <div className="specs">
            <div>
              Movie Name
            </div>
            <div>
              countrys (Na,Us)
            </div>
          </div>
          <div>
            <ul className="tables">
              {Object.keys(results).map(key => (
                <div className="tables__country" key={key}>
                  <div>{key}</div>
                  <div className="tables__country__headers">
                    <span className="tables__country__age">Age</span>
                    <span className="tables__country__female">Female</span>
                    <span className="tables__country__male">Male</span>
                  </div>
                  {Object.keys(results[key]).map(ageKey => (
                    <div
                      key={
                        results[key][ageKey].label +
                          results[key][ageKey].country
                      }
                      className="tables__country_lines"
                    >
                      <span className="tables__country__age">{ageKey}</span>
                      <span className="tables__country__female">
                        {formatNumber(results[key][ageKey].female)}
                      </span>
                      <span className="tables__country__male">
                        {formatNumber(results[key][ageKey].male)}
                      </span>
                    </div>
                  ))}
                  <div className="tables__totals">
                    <span className="tables__country__age">Total: </span>
                    <span className="tables__country__female" key="total-female">
                      {formatNumber(
                        calculateTotalsForGender(results[key], "female") || 0
                      )}
                    </span>
                    <span className="tables__country__male" key="total-male">
                      {formatNumber(
                        calculateTotalsForGender(results[key], "male") || 0
                      )}
                    </span>
                  </div>
                </div>
              ))}
            </ul>
          </div>
          <div className="print-footer">
            <img className="print-footer__logo" src="https://s3-eu-west-1.amazonaws.com/reach-calculator-v2/img/logo.jpg" />
          </div>
        </div>
        <div className="page page__back" >
          Easy access
          contact
        </div>
      </div>
    );
  }
}

const PrintPage = connect(mapStateToProps)(PrintPageContainer);
export default PrintPage;



// WEBPACK FOOTER //
// ./src/components/PrintPage.js